import { authorizeRequest } from '@u/http/authorizeRequest'
import { apiOrigin, baseURL } from '@u/http/apiOrigin'
import { createHttpClient } from '@u/http/createHttpClient'
import { helper } from '@u/helper'
import { clearObservedUser } from '@/observability/faro'

export { apiOrigin, baseURL }

/** Screens (TV displays) go back to their own login on 401/403. */
function handleScreenResponseError(error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
      case 403:
        clearObservedUser()
        window.location.href = '/screen/login'
        break
      default:
        return Promise.reject(error)
    }
  } else {
    helper.toastDanger('erreur serveur')
    return Promise.reject(error)
  }
}

const apiClientScreen = createHttpClient({
  baseURL: apiOrigin,
  onRequest: authorizeRequest,
  onResponseError: handleScreenResponseError
})

export default apiClientScreen
